<script lang="ts" setup>
import ArrowIconDown from "assets/icons/arrows/16/chevron-down.svg?component";
import ArrowIconUp from "assets/icons/arrows/16/chevron-up.svg?component";
import AppButton from "~/components/ui/buttons/AppButton.vue";
import AppLink from "~/components/ui/links/AppLink.vue";
import type {ICatalogCategory} from "~/shared/interfaces/catalog";

defineProps<{
  category: ICatalogCategory
  parentCategory: ICatalogCategory
}>()

const emits = defineEmits(['close'])

const contentContainer = ref<HTMLDivElement>()
const isOpen = ref(false)
const contentHeight = ref('132px')

function setMaxContentHeight(state: boolean) {
  if (state) {
    contentHeight.value = `${contentContainer.value?.scrollHeight}px`
  } else {
    contentHeight.value = `132px`
  }

  isOpen.value = state
}

function closeMenu() {
  emits('close')
}
</script>

<template>
  <div class="catalog-menu__child">
    <AppLink
      type="black"
      :url="`/catalog/${parentCategory.slug}/${category.slug}`"
      :text="category.name"
      @click="closeMenu"
    />
    <div
      class="catalog-menu__child-items"
      v-if="category.childCategories.length"
      :style="{'max-height': contentHeight}"
      ref="contentContainer"
    >
      <template
        v-for="subItem in category.childCategories"
      >
        <AppLink
          type="black"
          class="catalog-menu__sub-child"
          v-if="subItem.isShow"
          :url="`/catalog/${parentCategory.slug}/${category.slug}/${subItem.slug}`"
          :text="subItem.name"
          @click="closeMenu"
        />
      </template>
    </div>
    <AppButton
      v-if="category.childCategories.length > 5 && !isOpen"
      type="ghost"
      text="Ещё"
      :icon="ArrowIconDown"
      direction="row-reverse"
      size="s"
      @click="setMaxContentHeight(true)"
    />
    <AppButton
      v-if="isOpen"
      type="ghost"
      text="Свернуть"
      :icon="ArrowIconUp"
      direction="row-reverse"
      size="s"
      @click="setMaxContentHeight(false)"
    />
  </div>
</template>

<style lang="scss" scoped>
.catalog-menu {
  &__child {
    & > a {
      font-weight: 500;
    }

    &-items {
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin-top: 8px;
      @include font(14px, 20px);
      overflow: hidden;
      transition: max-height .3s;
    }
  }

  .button {
    @include font(14px, 13px);
    margin-top: 8px;
  }
}
</style>
